export const TECHNICAL_DOCUMENT_TEMPLATE = `# **[TITLE]**
## **TECHNICAL DOCUMENTATION**

### *DrillDocs Production Environment*

---

**Document Version:** 1.0  

| **Document Information** | **Details** |
|--------------------------|-------------|
| **Document Title** | [TITLE] - Technical Documentation |
| **Version** | 1.0 |
| **Classification** | Internal Use - Technical Operations |
| **Author** |  |
| **Technical Lead** |  |
| **Reviewer** |  |
| **Approver** |  |
| **Creation Date** | [DATE] |

---

> *"[QUOTE]"*

---

## Table of Contents

1. [What It Is](#what-it-is)
2. [What It Does](#what-it-does)
3. [Current Status](#current-status)
4. [Access Information](#access-information)
5. [Key Resources](#key-resources)
6. [Common Commands](#common-commands)
7. [Configuration Notes](#configuration-notes)
8. [Known Issues](#known-issues)
9. [Resource Usage](#resource-usage)
10. [Troubleshooting](#troubleshooting)

---

## What It Is

[Brief description of the system/service - what it is, how long it's been running, general architecture]

## What It Does

- [Key function 1]
- [Key function 2]
- [Key function 3]
- [Key function 4]
- [Key function 5]

## Current Status

\`\`\`
STATUS: Running
UPTIME: [X] days
VERSION: [version]
[Additional status info]
\`\`\`

[Current operational status description]

## Access Information

**Endpoints**:
- [URL/endpoint information]

**Authentication**:
- [Authentication method]

**Network**:
- [Network configuration]

## Key Resources

**[Component 1]**:
- [Details]
- [Configuration]
- [Version]

**[Component 2]**:
- [Details]
- [Configuration]

**Storage**:
- [Storage configuration]

**Networking**:
- [Network setup]

## Common Commands

Check status:
\`\`\`bash
[command]
\`\`\`

View logs:
\`\`\`bash
[command]
\`\`\`

Restart service:
\`\`\`bash
[command]
\`\`\`

[Additional commands]

## Configuration Notes

**[Configuration Area 1]**:
- [Configuration details]
- [Important settings]

**[Configuration Area 2]**:
- [Configuration details]
- [Important settings]

**Security**:
- [Security configuration]

## Known Issues

**[Issue 1]**:
- [Description]
- [Impact]
- [Workaround]

> **WARNING**: [Important warning if needed]

**Minor issues**:
- [Minor issue 1]
- [Minor issue 2]

## Resource Usage

**Compute**:
- CPU: [usage]
- Memory: [usage]
- [Other metrics]

**Storage**:
- [Storage usage]

**Network**:
- [Network usage]

[Resource usage summary]

## Troubleshooting

**[Problem 1]**:
\`\`\`bash
[troubleshooting commands]
\`\`\`

**[Problem 2]**:
\`\`\`bash
[troubleshooting commands]
\`\`\`

**Emergency procedures**:
\`\`\`bash
[emergency commands]
\`\`\`

[Troubleshooting summary]

---`;

export const generateDocumentContent = (title, quote = "Good documentation is the foundation of reliable systems.") => {
  const date = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
  
  return TECHNICAL_DOCUMENT_TEMPLATE
    .replace(/\[TITLE\]/g, title.toUpperCase())
    .replace(/\[DATE\]/g, date)
    .replace(/\[QUOTE\]/g, quote);
};